import Vue from 'vue'
import Vuex from 'vuex'
import VueLogger from 'vuejs-logger';
import store from './store'
import router from './router'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import '@voerro/vue-tagsinput/dist/style.css'


import App from './App.vue'

import ClientOAuth2 from 'client-oauth2'
var manualGzAuth = new ClientOAuth2({
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID,
  accessTokenUri: process.env.VUE_APP_KEYCLOAK_ACCESS_TOKEN_URI,
  authorizationUri: process.env.VUE_APP_KEYCLOAK_AUTHORIZATION_URI,
  redirectUri: 'dummy',
  scopes: ['openid']
})

var anonymousToken = ""

const options = {
  isEnabled: true,
  logLevel : Vue.config.productionTip  ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, options);

import * as Keycloak from 'keycloak-js'
//keycloak init options
let initOptions = {
  //url: process.env.VUE_APP_KEYCLOAK_URL, realm: process.env.VUE_APP_KEYCLOAK_REALM, clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID, onLoad:'login-required'
  url: process.env.VUE_APP_KEYCLOAK_URL, realm: process.env.VUE_APP_KEYCLOAK_REALM, clientId: process.env.VUE_APP_KEYCLOAK_CLIENTID, onLoad:'check-sso'
}
let keycloak = Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).success((auth) =>{
  console.log('keycloak init')
  if(!auth) {
    console.log('Unauthenticated - Guest Mode')
    console.log(Vue.prototype.$getAccessToken())
    // get anonymous access token
    // window.location.reload();
    // use manual fetching for now
    manualGzAuth.owner.getToken('anonymous.test@gozhere.com', '123456')
      .then(function (user) {
        console.log(user) //=> { accessToken: '...', tokenType: 'bearer', ... }
        anonymousToken = user.accessToken

        setInterval(() => {
          console.log('refreshing...')
          user.refresh().then(function (updatedUser) {
            console.log(updatedUser !== user) //=> true
            console.log(updatedUser.accessToken)
            anonymousToken = updatedUser.accessToken
          })
        }, 60000)

        // setTimeout(() => {  
        //   console.log("Logging in...");
        //   //keycloak.login() 
        // }, 2000);
      

        mountApp()
      })

  } else {
    console.log("Authenticated")
    //Vue.$log.info("Authenticated");

    // TODO: Maybe dont store the token in the localstore, rather use it direct from the keycloak.token object
    localStorage.setItem("vue-token", keycloak.token);
    localStorage.setItem("vue-refresh-token", keycloak.refreshToken);

    setInterval(() =>{
      keycloak.updateToken(70).success((refreshed)=>{
        if (refreshed) {
          console.debug('Token refreshed');
        } else {
          console.warn('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
        }
      }).error(()=>{
          console.error('Failed to refresh token');
      });

    }, 60000)

    mountApp()

  }

  /*
  setTimeout(() => {  
    console.log("World!"); }, 2000);

  */
  

  


  
}).error(() =>{
  Vue.$log.error("Authenticated Failed");
});

import "./assets/scss/custom.scss";
Vue.use(BootstrapVue);

Vue.use(Vuex);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormWizard)
Vue.component('tags-input', VoerroTagsInput);
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import 'bootstrap/scss/bootstrap.scss';
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)

Vue.config.productionTip = false
Vue.prototype.$keycloak = keycloak


function mountApp() {
  new Vue({
    render: h => h(App),
    store: new Vuex.Store(store),
    router,
    keycloak
  }).$mount('#app')
}



Vue.prototype.$getAccessToken = function() {
  if (keycloak.token == null) {
    console.log('keycloak token is null, giving you anonymous')
    return anonymousToken
  } else {
    console.log('keycloak token is not null')
    return keycloak.token
  }
}




/**
 * anonymous token
 */

// setInterval(() => {
//   console.log('getting access token...')
//   console.log(anonymousToken)
// }, 1000)